import { getAuthConnection } from "./config.js";

/*
export function getAPISample(query) {
  return getAuthConnection().get(`some-address${query}`);
}

export function postAPISample(data) {
  return getAuthConnection().post(`some-address`, data);
}

export function putAPISample(data) {
  return getAuthConnection().put(`some-address/${id}`, data);
}

export function delAPISample(id) {
  return getAuthConnection().delete(`some-address/${id}`);
}
*/

export function getCategory(query) {
  return getAuthConnection().get(`category/?${query}`);
}

export function getItemList(query = "") {
  return getAuthConnection().get(`item/?${query}`);
}

export function getStatistics(query) {
  return getAuthConnection().get(`statistics/data?${query}`);
}

export function getMaxBase(code) {
  return getAuthConnection().get(`statistics/maxbase/${code}/`);
}

export function getFavorite() {
  return getAuthConnection().get("favorite");
}

export function postFavorite(data) {
  return getAuthConnection().post("favorite/", data);
}

export function deleteFavorite(id) {
  return getAuthConnection().delete(`favorite/${id}/`);
}

export function getReferenceList(query = "") {
  return getAuthConnection().get(`reference?${query}`);
}

export function postReference(data) {
  return getAuthConnection().post(`reference`, data);
}

export function getReference(id) {
  return getAuthConnection().get(`reference/${id}`);
}

export function putReference(id, data) {
  return getAuthConnection().put(`reference/${id}`, data);
}

export function delReference(id) {
  return getAuthConnection().delete(`reference/${id}`);
}
